import { Injectable, EventEmitter } from '@angular/core';
import { OneSignal, OSNotification, OSNotificationPayload } from '@ionic-native/onesignal/ngx';
import { Storage } from '@ionic/storage';
import { GLOBAL } from '../../../global';
import { NotificationsPage } from '../notifications/notifications.page';
import { ModalController } from '@ionic/angular';
import { Platform } from '@ionic/angular';



@Injectable({
  providedIn: 'root'
})

export class pushNotiService {
  token;
  url
  mensajes: OSNotificationPayload[] = [];
  

  userId: string;
  subscriptionstring
  pushListener = new EventEmitter<OSNotificationPayload>();



  constructor( 
    private platform: Platform,
    private oneSignal: OneSignal,
    
               private storage: Storage,
               public modalController: ModalController,
               ) {
                this.url= GLOBAL.url;

    this.cargarMensajes();
  }

  async getMensajes() {
    await this.cargarMensajes();
    return [...this.mensajes];
  }

  getCountMensajes() {
    // await this.cargarMensajes();
    return this.mensajes.length;
  }

  async  config(){

        this.oneSignal.startInit('e7b5de97-5e80-4b58-b129-e46110b6ea06', '588081839106');
        
        this.oneSignal.inFocusDisplaying( this.oneSignal.OSInFocusDisplayOption.Notification );
    
        this.oneSignal.handleNotificationReceived().subscribe( ( noti ) => {
        // do something when notification is received
        // console.log('Notificación recibida', noti );
        this.notificacionRecibida( noti );
        });
    
        this.oneSignal.handleNotificationOpened().subscribe( async( noti ) => {
          // do something when a notification is opened
          // console.log('Notificación abierta', noti );
        });
    
    
        // Obtener ID del suscriptor
        this.oneSignal.getIds().then( info => {
          this.userId = info.userId || '';
          // console.log(this.userId);
        });
    
        this.oneSignal.endInit();
    
      }
    
      async getUserIdOneSignal() {
        // console.log('Cargando userId');
        // Obtener ID del suscriptor;
          // console.log('plataforma')
          const info = await this.oneSignal.getIds();
          this.userId = info.userId;
          return info.userId;
      }


      async Subscribcion(tag, id){
        // this.oneSignal.sendTag(tag, id).subscribe(
        //   res=>{
        //     console.log(res);
        //   }
        // )
      }
    
      async notificacionRecibida( noti: OSNotification ) {
    
        await this.cargarMensajes();
    
        const payload = noti.payload;
    
        const existePush = this.mensajes.find( mensaje => mensaje.notificationID === payload.notificationID );
    
        if ( existePush ) {
          return;
        }
        // this.registerObject(payload);
        this.mensajes.unshift( payload );
        this.pushListener.emit( payload );
        await this.guardarMensajes();
    
      }
    
      guardarMensajes() {
        this.storage.set('mensajes', this.mensajes);
      }

      async addTagNotify(key:string, tag:string){
        let res = await this.oneSignal.sendTag(key, tag );
        return res;
      }
    
      async cargarMensajes() {
    
        this.mensajes =  await this.storage.get('mensajes') || [];
        return this.mensajes;
      }
    
      async borrarMensajes() {
        await this.storage.clear();
        this.mensajes = [];
        this.guardarMensajes();
      }
    
    }
    